import ErroService from '../services/erro.service';

export const error = {
    namespaced: true,
    state: {
        erroList: []
    },
    actions: {
        async getErrorList({ commit }) {
            const resp = await ErroService.getErrorList();
            if (resp.status === 200) {
                commit('SET_ERRO_LIST', resp.data);
            }
            return resp.status;
        },
        async getError(_, erroId){
            const resp = await ErroService.getError(erroId);
            return resp.data
        },
      
        async createError(_, newErro) {
            const resp = await ErroService.createError(newErro);
            return resp;
        },
        async deleteError(_, erroId) {
            const resp = await ErroService.deleteError(erroId);
            return resp.status;
        },
    },
    mutations: {
        SET_ERRO_LIST(state, erroList) {
          state.erroList = erroList;
        },
      },
}